module.exports = __webpack_public_path__ + "img/baseline-menu-24px.f3858d88.svg";